Object.assign(exports, require("./links"));
// Used also by webpack, therefore CommonJS syntax.